import { render } from "./InspirationWindow.vue?vue&type=template&id=3a4ced3a&scoped=true"
import script from "./InspirationWindow.vue?vue&type=script&lang=js"
export * from "./InspirationWindow.vue?vue&type=script&lang=js"

import "./InspirationWindow.vue?vue&type=style&index=0&id=3a4ced3a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3a4ced3a"

export default script